// src/App.tsx
import React from "react";
import {
  createBrowserRouter,
  RouterProvider,
  useNavigate,
} from "react-router-dom";
import RegisterPage from "./pages/RegistrationPage/RegisterPage";
import LoginPage from "./pages/LoginPage";
import ScenePage2 from "./pages/ScenePage2";
import DoctorPersonalPage from "./pages/DoctorPersonalPage";
import { DashboardPage, ErrorPage, MainPage, RootLayout } from "./pages";
import { RouterPathEnum } from "shared/enums/commonEnums";
// import motionStore from "stores/motionStore";
import charactersStore from "stores/charactersStore";
import CreateCharacterPage from "./pages/CreateCharacterPage";

import "./App.css";
import "sanitize.css";
import ScenePage3 from "./pages/ScenePage3";
import { FirstPage } from "pages/FirstPage/FirstPage";
import { KeyLostPage } from "pages/KeyLostPage/KeyLostPage";
import { AboutExplanationPage } from "pages/AboutExplanationPage/AboutExplanationPage";
import { PersonalAccountFirstPage } from "pages/PersonalAccuntFirstPage/PersonalAccountFirstPage";
import { WeekKBGUPage } from "pages/weekKBGU/WeekKBGUPage";
import { MetabolismPage } from "pages/MetabolismPage/MetabolismPage";
import { RoutingPage } from "pages/RoutingPage/RoutingPage";

// 🔹 Оборачиваем CreateCharacterPage, чтобы передать onBack и onCreated
const CreateCharacterWrapper: React.FC = () => {
  const navigate = useNavigate();

  return (
    <CreateCharacterPage
      onBack={() => navigate(RouterPathEnum.Main)}
      onCreated={async (updatedChars) => {
        // Обновляем список персонажей в charactersStore
        charactersStore.characters = updatedChars;
        navigate(RouterPathEnum.Main);
      }}
    />
  );
};

const router = createBrowserRouter([
  { path: RouterPathEnum.FirstPage, element: <FirstPage /> },
  // {
  //   path: RouterPathEnum.Main,
  //   element: <RootLayout />,
  //   errorElement: <ErrorPage />,
  //   children: [
  //     { index: true, element: <MainPage /> },
  //     // { path: RouterPathEnum.SceneMuscle, element: <ScenePage2 /> },
  //     // { path: RouterPathEnum.SceneMap, element: <ScenePage3 /> },
  //     { path: RouterPathEnum.Dashboard, element: <DashboardPage /> },
  //     { path: RouterPathEnum.DoctorPage, element: <DoctorPersonalPage /> },
  //     // { path: RouterPathEnum.Profile, element: <ProfilePage /> },

  //     {
  //       path: RouterPathEnum.CreateCharacterPage,
  //       element: <CreateCharacterWrapper />,
  //     },
  //   ],
  // },
  {
    path: RouterPathEnum.Profile,
    element: <RootLayout />,
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <PersonalAccountFirstPage /> },
      {
        path: RouterPathEnum.CreateCharacterPage,
        element: <CreateCharacterWrapper />,
      },
      { path: RouterPathEnum.Main, element: <MainPage /> },
      { path: RouterPathEnum.KBGU, element: <WeekKBGUPage /> }, // /app/profile/kbgu
      { path: RouterPathEnum.SceneMap, element: <ScenePage3 /> },
      { path: RouterPathEnum.SceneMuscle, element: <ScenePage2 /> },
      { path: RouterPathEnum.Metabolism, element: <MetabolismPage /> },
      { path: RouterPathEnum.Dashboard, element: <DashboardPage /> },
      { path: RouterPathEnum.DoctorPage, element: <DoctorPersonalPage /> },
    ],
  },
  { path: RouterPathEnum.KeyLost, element: <KeyLostPage /> },
  { path: RouterPathEnum.Explanation, element: <AboutExplanationPage /> },
  { path: RouterPathEnum.Auth, element: <LoginPage /> },
  { path: RouterPathEnum.RegistrationPage, element: <RegisterPage /> },
  { path: RouterPathEnum.Routing, element: <RoutingPage /> },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
